export default __webpack_public_path__ + "static/media/client-validation.ded10874.webp";